import axios from 'axios';

const baseUrl = process.env['REACT_APP_BASE_URL'];
const apiVersion = process.env['REACT_APP_API_VERSION'];

const logClient = axios.create({
  baseURL: `${baseUrl}/${apiVersion}`,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000,
});

export type ClientErrorLogPayload = {
  errorId: string;
  traceId: string;
  message: string;
  errorName?: string;
  stack?: string;
  componentStack?: string;
  url: string;
  userAgent: string;
  timestamp: string;
};

export const logClientError = async (payload: ClientErrorLogPayload) => {
  try {
    await logClient.post('/logs/client', payload, {
      headers: {
        'x-client-error-id': payload.errorId,
        'x-client-trace-id': payload.traceId,
      },
    });
  } catch {
    // Never break user flow if logging fails.
  }
};
